const MenuSvg = () => {

	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="4" y="6" width="16" height="1.4" rx="0.7" fill="#20467B"/>
			<rect x="4" y="11" width="16" height="1.4" rx="0.7" fill="#20467B"/>
			<rect x="4" y="16" width="16" height="1.4" rx="0.7" fill="#20467B"/>
		</svg>

	);
}

export default MenuSvg;
